import React, { useEffect, useState } from 'react'
import { translate } from '../assets/js/functions';
import Layout from "../components/Layout";
import HomeButton from "../components/Partials/HomeButton";
import Tools from "../components/Partials/Tools";
import {getPageText} from "../assets/js/api";
import parse from 'html-react-parser';

import Cuidar from "../assets/img/cuidar.svg";

export default function Info(){

    const [informacio, setInformacio] = useState(null);
    const [objectius, setObjectius] = useState(null);
    const [credits, setCredits] = useState(null);

    useEffect(() => {
        getPageText('ww1_15').then(res => {
            setInformacio(res);
        });
        getPageText('ww1_16').then(res => {
            setObjectius(res);
        });
        getPageText('ww1_17').then(res => {
            setCredits(res);
        });
    }, [])

    return (
        <Layout pageMeta={{
            customCssClass: 'info'
        }}>
            <div className="page-container">
                <HomeButton/>
                <Tools/>
                <div className="columns is-desktop is-gapless h-100">
                    <div className="column is-7-widescreen has-background-empatitzant">
                        <div className="py-8 px-8">
                            <h1><img src={Cuidar} alt={translate('Cuidar!')} width="650" height="187"/></h1>
                            <p className="my-8 is-size-7 has-text-weight-semibold">
                                {informacio?parse(informacio.body):''}
                            </p>
                            <div className="flow">
                                {objectius?parse(objectius.body):''}
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="py-8 px-8 is-flex is-flex-direction-column is-justify-content-center h-100">
                            <div className="flow">
                                {credits?parse(credits.body):''}
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </Layout>
    )
}
